import React, { useState } from "react";
import {
  EuiButton,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiFilePicker,
  EuiSpacer,
  EuiSuperSelect,
  EuiDatePicker,
  EuiTextArea,
  htmlIdGenerator,
  EuiRadioGroup,
  EuiComboBox,
} from "@elastic/eui";

import { useHistory } from "react-router-dom";
import { v4 } from "uuid";
import { useForm } from "react-hook-form";
import { Moment } from "moment";

// import { NIIHome } from "./NiiHome";

import { applicationClass, formClass } from "../styles";
import { eduOptions, provinceOptions } from "../common/Options";
import { db, storage } from "../firebase/firebase";

const idPrefix = htmlIdGenerator()();

export const NiiApplicationForm: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [eduLevel, setEduLevel] = useState<string>("");
  const [eduErrors, setEduError] = useState<boolean>(false);
  const [province, setProvince] = useState<string>("");
  const [provinceErrors, setProvinceError] = useState(false);
  const [dateOfBirth, setdateOfBirth] = useState<Moment>();
  const [dobErrors, setDobErrors] = useState<boolean>(false);
  const [sdgErrors, setSDGErrors] = useState<boolean>(false);

  const sdgOptions = [
    {
      label: "SDG 1. No Poverty",
    },
    {
      label: "SDG 2. Zero Hunger",
    },
    {
      label: "SDG 3. Good Health and Well-Being",
    },
    {
      label: "SDG 4. Quality Education",
    },
    {
      label: "SDG 5. Gender Equality",
    },
    {
      label: "SDG 6. Clean Water and Sanitation",
    },
    {
      label: "SDG 7. Affordable and Clean Energy",
    },
    {
      label: "SDG 8. Decent Work and Economic Growth",
    },
    {
      label: "SDG 9. Industry, Innovation, and Infrastructure",
    },
    {
      label: "SDG 10. Reduced Inequalities",
    },
    {
      label: "SDG 11. Sustainable Cities and Communities",
    },
    {
      label: "SDG 12. Responsible Consumption and Production",
    },
    {
      label: "SDG 13. Climate Action",
    },
    {
      label: "SDG 14. Life Below Water",
    },
    {
      label: "SDG 15. Life on Land",
    },
    {
      label: "SDG 16. Peace, Justice, and Strong Institutions",
    },
  ];

  const radios = [
    {
      id: `${idPrefix}0`,
      label: "Yes",
    },
    {
      id: `${idPrefix}1`,
      label: "No",
    },
  ];

  const permissions = [
    {
      id: `${idPrefix}0`,
      label: "Yes",
    },
    {
      id: `${idPrefix}1`,
      label: "No",
    },
  ];

  const [radioIdSelected, setRadioIdSelected] = useState(`${idPrefix}0`);
  const [radioIdSelectedPerm, setRadioIdSelectedPerm] = useState(
    `${idPrefix}0`
  );
  const [options] = useState(sdgOptions);
  const [selectedSDGOptions, setSelectedSDG] = useState([]);

  const onSDGChange = (selectedSDGOptions: any) => {
    setSelectedSDG(selectedSDGOptions);
  };
  const onRadioChange = (optionId: any) => {
    setRadioIdSelected(optionId);
  };

  const permissionChange = (optionId: any) => {
    setRadioIdSelectedPerm(optionId);
  };

  const [files, setFiles] = useState<any>(null);
  const onChange = (fs: any) => {
    setFiles(fs);
  };

  const { register, handleSubmit, errors } = useForm();

  const onFormSubmit = async (data: any) => {
    console.log(files);

    if (!province) {
      setProvinceError(true);
      return;
    }

    if (!eduLevel) {
      setEduError(true);
      return;
    }

    if (selectedSDGOptions.length < 1) {
      setSDGErrors(true);
      return;
    }

    if (!dateOfBirth) {
      setDobErrors(true);
      return;
    } else {
      setLoading(true);
      const id = v4();

      if (files) {
        await storage()
          .ref(`/nii-applications/${id}/${files[0].name}`)
          .put(files[0])
          .then((x) =>
            x.ref.getDownloadURL().then(async (url) => {
              await db()
                .collection("nii-applications")
                .doc(id)
                .set({
                  id,
                  ...data,
                  fileUrl: url,
                  sdgs: selectedSDGOptions,
                  province,
                  eduLevel,
                  hasPrototype: radios.map((x) => x.id === radioIdSelected)[0],
                  isPermissionGiven: permissions.map(
                    (x) => x.id === radioIdSelected
                  )[0],
                  dob: db.Timestamp.fromDate(dateOfBirth.toDate()),
                  timestamp: db.Timestamp.now(),
                });
            })
          );
      } else {
        await db()
          .collection("nii-applications")
          .doc(id)
          .set({
            id,
            ...data,
            sdgs: selectedSDGOptions,
            province,
            eduLevel,
            hasPrototype: radios.map((x) => x.id === radioIdSelected)[0],
            isPermissionGiven: permissions.map(
              (x) => x.id === radioIdSelected
            )[0],
            dob: db.Timestamp.fromDate(dateOfBirth.toDate()),
            timestamp: db.Timestamp.now(),
          });
      }
    }

    localStorage.setItem("recipient", data.email);
    localStorage.setItem("recipeintsName", data.innovatorName);

    history.push("/submitted");
  };

  const handleChange = (date: any) => {
    setdateOfBirth(date);
  };

  return (
    <div>
      <div></div>
      <div className={applicationClass}>
        <EuiForm
          component="form"
          className={formClass}
          onSubmit={handleSubmit(onFormSubmit)}
          isInvalid={dobErrors}
        >
          <EuiFormRow
            fullWidth
            label="Name of Innovator"
            helpText="If you are in a group, add the name of the team leader."
          >
            <EuiFieldText
              name="innovatorName"
              inputRef={register({ required: true })}
              isInvalid={errors.innovatorName && true}
              fullWidth
            />
          </EuiFormRow>
          <EuiFormRow
            label="Please select your province."
            isInvalid={provinceErrors}
            helpText="Note that the initiative is being implemented in these provinces only: Lusaka, Southern, North Western, Copperbelt, Western and Luapula."
            fullWidth
          >
            <EuiSuperSelect
              options={provinceOptions}
              valueOfSelected={province}
              isInvalid={provinceErrors}
              fullWidth
              onChange={(value: any) => setProvince(value)}
            />
          </EuiFormRow>
          <EuiFormRow label="Date of Birth" isInvalid={false} fullWidth>
            <EuiDatePicker
              isInvalid={dobErrors}
              selected={dateOfBirth}
              placeholder="Enter date of birth"
              onChange={handleChange}
              fullWidth
            />
          </EuiFormRow>
          <EuiFormRow
            label="NRC Number"
            helpText="Enter your NRC, i.e., 123456/78/9."
            fullWidth
          >
            <EuiFieldText
              name="nrcNumber"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>
          <EuiFormRow
            label="Contact Number"
            helpText="Your primary contact number."
            fullWidth
          >
            <EuiFieldText
              name="contact"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow label="Alternative Contact Number" fullWidth>
            <EuiFieldText
              name="altContact"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow label="Email address" fullWidth>
            <EuiFieldText
              name="email"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow
            label="Highest Level of Education"
            isInvalid={eduErrors}
            fullWidth
          >
            <EuiSuperSelect
              options={eduOptions}
              valueOfSelected={eduLevel}
              fullWidth
              isInvalid={eduErrors}
              onChange={(value: any) => setEduLevel(value)}
            />
          </EuiFormRow>

          <EuiFormRow
            label="Title of Innovation"
            helpText="Maximum of 50 words."
            fullWidth
          >
            <EuiFieldText
              name="title"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow
            label="Brief Innovation Description"
            helpText="Maximum of 200 words."
            fullWidth
          >
            <EuiTextArea
              name="description"
              placeholder="Give a brief description on what your innovation is and what problem is being solved or process being improved"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow
            label="Commercial Viability of the Innovation"
            helpText="Maximum of 200 words."
            fullWidth
          >
            <EuiTextArea
              name="viability"
              placeholder="Explain how your innovation will generate income for you or others or how it can assist in improving operations of existing businesses, specify your target market/potential offtakers"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow
            label="Technical Feasibility of the Innovation"
            helpText="Maximum of 200 words."
            fullWidth
          >
            <EuiTextArea
              name="feasibility"
              placeholder="Explain how your innovation is designed and what prototype exists if any"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow
            label="Anticipated Social Impact"
            helpText="Maximum of 200 words."
            fullWidth
          >
            <EuiTextArea
              name="socialImpact"
              placeholder="Explain how your innovation can improve the lives of others"
              inputRef={register({ required: true })}
              fullWidth
            />
          </EuiFormRow>

          <EuiFormRow
            label="Sustainable Development Goals Impacted"
            isInvalid={sdgErrors}
            fullWidth
          >
            <EuiComboBox
              placeholder="Select from the list"
              options={options}
              selectedOptions={selectedSDGOptions}
              onChange={onSDGChange}
              isInvalid={sdgErrors}
              isClearable={true}
              data-test-subj="demoComboBox"
            />
          </EuiFormRow>

          <EuiFormRow>
            <EuiRadioGroup
              options={radios}
              idSelected={radioIdSelected}
              onChange={(id) => onRadioChange(id)}
              name="hasPrototype"
              legend={{
                children: (
                  <span>Do you have a prototype for your innovation?</span>
                ),
              }}
            />
          </EuiFormRow>

          <EuiFormRow>
            <EuiRadioGroup
              options={permissions}
              idSelected={radioIdSelectedPerm}
              onChange={(id) => permissionChange(id)}
              name="permissionGiven"
              legend={{
                children: (
                  <span>
                    Do you grant us permission to share your innovation with our
                    partners for similar or future engagements?
                  </span>
                ),
              }}
            />
          </EuiFormRow>

          <EuiFormRow
            label="Supporting Image"
            helpText="Add an image to support your innovation"
            fullWidth
          >
            <EuiFilePicker
              fullWidth
              accept="image/x-png,image/gif,image/jpeg"
              onChange={(files) => {
                onChange(files);
              }}
            />
          </EuiFormRow>

          <EuiSpacer />

          <EuiSpacer />

          <EuiButton fill type="submit" isLoading={loading}>
            Submit Innovation
          </EuiButton>
        </EuiForm>
      </div>
    </div>
  );
};
